exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".XjP0TvYYMJwnvlfVnKvvu{margin-top:74px;background-color:#454579;padding-bottom:1em}ul._1Ga1EkVIDG0-jwm9kFUJrF{display:flex;height:64px;line-height:64px}ul._1Ga1EkVIDG0-jwm9kFUJrF li{list-style-type:none;flex:1;background-color:#322d63;font-family:fira_sansregular,Arial;font-size:26px;cursor:pointer;transition:all .2s}ul._1Ga1EkVIDG0-jwm9kFUJrF li._1a4J_JHDwXGMqPuHCe7hzz,ul._1Ga1EkVIDG0-jwm9kFUJrF li._1a4J_JHDwXGMqPuHCe7hzz:hover{background-color:#454579;color:#b3d2fa}ul._1Ga1EkVIDG0-jwm9kFUJrF li:hover{background-color:#b3d2fa;color:#322d63}@media screen and (max-width:900px){.XjP0TvYYMJwnvlfVnKvvu{margin-top:49px}ul._1Ga1EkVIDG0-jwm9kFUJrF li{font-size:1.1em;height:50px;line-height:50px}}", ""]);

// exports
exports.locals = {
	"gameList": "XjP0TvYYMJwnvlfVnKvvu",
	"gameTabs": "_1Ga1EkVIDG0-jwm9kFUJrF",
	"active": "_1a4J_JHDwXGMqPuHCe7hzz"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules!./~/sass-loader!./src/components/Common/Common.scss
 ** module id = 317
 ** module chunks = 0
 **/